import { ComponentType } from 'react';
import { Timestamp } from 'firebase/firestore';
import { AlexandriteLeague } from './alexandrite';
import { AmethystLeague } from './amethyst';
import { DiamondLeague } from './diamond';
import { DiamondGlowLeague } from './diamond-glow';
import { JadeiteImperialLeague } from './jadeite-imperial';
import { RedBerylLeague } from './red-beryl';
import { RubyLeague } from './ruby';
import { TanzaniteLeague } from './tanzanite';

export type CashbackBonusType = `cashback-${number}-${number}`;
export type BonusType = '2x1' | CashbackBonusType;
export type ModeLeagueType = 'main' | 'arena';

export interface TokenSelectionProps {
  idToken: number;
  idUser: string;
  claimedAt: Timestamp; // 🔥 momento en que el usuario selecciona el token
}

export interface ArenaInfoProps {
  baseTokens: number;
  cardName: string;
  cardImg: string;
  loot: LootProps;
  winners: WinnersProps;
}

export interface SeasonProps {
  cardName: string;
  cardImg: string;
  value: number;
  enabled: boolean;
  bgColor: string;
  color: string;
  baseTokens: number;
  endDate: Timestamp;
  seasonNumber: number;
  bonus: BonusType[];
  referralTokens: number;
  arena: ArenaInfoProps;
  winners: WinnersProps;
  selections: TokenSelectionProps[];
}

export interface LootProps {
  w1: number;
  r1: number;
  w2: number;
  r2: number;
  w3: number;
  r3: number;
  w4?: number | undefined;
  r4?: number | undefined;
  w5?: number | undefined;
  r5?: number | undefined;
  w6?: number | undefined;
  r6?: number | undefined;
  w7?: number | undefined;
  r7?: number | undefined;
  w8?: number | undefined;
  r8?: number | undefined;
  w9?: number | undefined;
  r9?: number | undefined;
  w10?: number | undefined;
  r10?: number | undefined;
  total: number;
}

export interface WinnersProps extends LootProps {
  show: boolean;
}

export interface AsyncLeagueProps {
  enabled: boolean;
  id: string;
  loot: LootProps;
  currentSeasonId: string;
}

export interface LeagueWithSeason extends AsyncLeagueProps {
  currentSeason: SeasonProps;
}

export interface InfoLeagueProps {
  id: string;
  icon?: string;
  name: string;
  path: string;
  active: boolean;
  description?: string;
  color: string;
  bgColor: string;
  borderColor: string;
  page: ComponentType;
}

export const LEAGUES: InfoLeagueProps[] = [
  AmethystLeague,
  TanzaniteLeague,
  RubyLeague,
  AlexandriteLeague,
  RedBerylLeague,
  JadeiteImperialLeague,
  DiamondGlowLeague,
  DiamondLeague,
];
